const SESSION_TOKEN_KEY = 'bridge.sessionToken';

export function readSessionToken(): string | null {
  return localStorage.getItem(SESSION_TOKEN_KEY);
}

export function writeSessionToken(token: string | null): void {
  if (token === null) localStorage.removeItem(SESSION_TOKEN_KEY);
  else localStorage.setItem(SESSION_TOKEN_KEY, token);
}

export function consumeSessionRedirect(): void {
  const hash = window.location.hash.replace(/^#/, '');
  const queryStart = hash.indexOf('?');
  if (queryStart < 0) return;
  const params = new URLSearchParams(hash.slice(queryStart + 1));
  const token = params.get('sessionToken');
  if (!token && !params.get('authError')) return;
  params.delete('sessionToken');
  params.delete('authProvider');
  params.delete('authError');
  const query = params.toString();
  window.location.hash = `${hash.slice(0, queryStart) || '/'}${query ? `?${query}` : ''}`;
  if (token) writeSessionToken(token);
}

export function observeSessionChanges(sync: () => void): () => void {
  const storage = (event: StorageEvent) => {
    if (event.storageArea === localStorage && (event.key === SESSION_TOKEN_KEY || event.key === null)) sync();
  };
  const visible = () => {
    if (document.visibilityState === 'visible') sync();
  };
  window.addEventListener('storage', storage);
  window.addEventListener('pageshow', sync);
  window.addEventListener('online', sync);
  document.addEventListener('visibilitychange', visible);
  return () => {
    window.removeEventListener('storage', storage);
    window.removeEventListener('pageshow', sync);
    window.removeEventListener('online', sync);
    document.removeEventListener('visibilitychange', visible);
  };
}
